import { sha256 } from 'js-sha256';

export const hashSha256 = (value: string): string => {
  return sha256(value);
};
